import React, { Component } from "react";
import "./submittedReportsStyles.css";
import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    TextField,
    IconButton,
    Grid,
} from "@material-ui/core";
import { Clear as ClearIcon } from "@material-ui/icons";
import { StyledContent } from "../../styles";

import DayPickerInput from "react-day-picker/DayPickerInput";
import { formatDate, parseDate } from "react-day-picker/moment";
import moment from "moment";
export default class Filters extends Component {
    render() {
        const {
            reportTitles,
            users,
            reportType,
            day,
            user,
            dateFrom,
            dateTo,
            setReportType,
            setArea,
            setDepartment,
            areas,
            departments,
            department,
            area,
            setUser,
            setDateFrom,
            setDateTo,
            jobID,
            setJobID,
            year,
            setYear,
            month,
            setMonth,
            setDayFrom,
            setClientName,
            clientName,
            clientDetails
        } = this.props;
        var title = clientDetails.title;
        return (
            <StyledContent style={{ padding: 0 }}>
                <Grid container spacing={0}>
                    <Grid item xs={12}>
                        <FormControl style={{ minWidth: 200 }}>
                            <InputLabel>Filter By Users</InputLabel>
                            <Select
                                value={user === false ? "all_users" : user}
                                onChange={(event) =>
                                    setUser(event.target.value)
                                }
                            >
                                <MenuItem value="all_users">All Users</MenuItem>
                                {users &&
                                    users.map((e) => {
                                        return (
                                            <MenuItem value={e.uid} key={e.uid}>
                                                {e.user_name}
                                            </MenuItem>
                                        );
                                    })}
                            </Select>
                        </FormControl>
                        <FormControl style={{ minWidth: 200, marginLeft: 20 }}>
                            <InputLabel>Filter By Report Type</InputLabel>
                            <Select
                                value={reportType}
                                onChange={(event) =>
                                    setReportType(event.target.value)
                                }
                            >
                                <MenuItem value="all_reports">
                                    All Reports
                                </MenuItem>
                                {reportTitles &&
                                    Object.keys(reportTitles).map((e) => {
                                        if (
                                            e !== "holiday_request" &&
                                            e !== "timesheets"
                                        ) {
                                            return (
                                                <MenuItem value={e} key={e}>
                                                    {reportTitles[e]}
                                                </MenuItem>
                                            );
                                        } else return null;
                                    })}
                            </Select>
                        </FormControl>

                        <FormControl style={{ minWidth: 200, marginLeft: 20 }}>
                            <InputLabel>Filter By Area</InputLabel>
                            <Select
                                value={area}
                                onChange={(event) =>
                                    setArea(event.target.value)
                                }
                            >
                                <MenuItem value="all_areas">All Areas</MenuItem>
                                {areas &&
                                    areas.map((e) => {
                                        return (
                                            <MenuItem value={e} key={e}>
                                                {e}
                                            </MenuItem>
                                        );
                                    })}
                            </Select>
                        </FormControl>
                        <FormControl style={{ minWidth: 200, marginLeft: 20 }}>
                            <InputLabel>Filter By Department</InputLabel>
                            <Select
                                value={department}
                                onChange={(event) =>
                                    setDepartment(event.target.value)
                                }
                            >
                                <MenuItem value="all_departments">
                                    All Departments
                                </MenuItem>
                                {departments &&
                                    departments.map((e) => {
                                        return (
                                            <MenuItem value={e} key={e}>
                                                {e}
                                            </MenuItem>
                                        );
                                    })}
                            </Select>
                        </FormControl>
                        <FormControl
                            style={{
                                marginLeft: 20,
                                minWidth: 200,
                                display: "initial",
                            }}
                        >
                            <TextField
                                label="Filter By Job ID"
                                value={jobID === false ? "" : jobID}
                                onChange={(event) => {
                                    setJobID(event.target.value);
                                }}
                            />
                            <IconButton>
                                <ClearIcon
                                    style={{ color: "red" }}
                                    onClick={() => setJobID(false)}
                                />
                            </IconButton>
                        </FormControl>
                    </Grid>
                    <br/>
                    <Grid xs={12}>
                        <FormControl
                            style={{
                                minWidth: 200,
                                display: "initial",
                            }}
                        >
                            <TextField
                                label="Filter By Year"
                                value={year === false ? "" : year}
                                onChange={(event) => {
                                    setYear(event.target.value);
                                }}
                            />
                        </FormControl>
                        <FormControl style={{ minWidth: 200, marginLeft: 20 }}>
                            <InputLabel>Filter By Month</InputLabel>
                            <Select
                                value={month}
                                onChange={(event) => {
                                    setMonth(event.target.value);
                                }}
                            >
                                <MenuItem value="select">Select Month</MenuItem>
                                <MenuItem value="jan">January</MenuItem>
                                <MenuItem value="feb">February </MenuItem>
                                <MenuItem value="mar">March</MenuItem>
                                <MenuItem value="apr">April</MenuItem>
                                <MenuItem value="may">May</MenuItem>
                                <MenuItem value="jun">June</MenuItem>
                                <MenuItem value="jul">July</MenuItem>
                                <MenuItem value="aug">August</MenuItem>
                                <MenuItem value="sep">September</MenuItem>
                                <MenuItem value="oct">October</MenuItem>
                                <MenuItem value="nov">November</MenuItem>
                                <MenuItem value="dec">December</MenuItem>
                            </Select>
                        </FormControl>

                        <div
                            style={{
                                width: "300px",
                                marginTop: 16,
                                display: "inline-flex",
                                flexDirection: "row",
                                zIndex: 300,
                            }}
                        >
                            <DayPickerInput
                                id="dateFrom"
                                value={dateFrom === false ? "" : dateFrom}
                                placeholder="Select Week"
                                formatDate={formatDate}
                                parseDate={parseDate}
                                format="DD-MM-YYYY"
                                component={(props) => (
                                    <FormControl
                                        style={{
                                            marginLeft: 20,
                                            minWidth: 200,
                                        }}
                                    >
                                        <TextField {...props} />
                                    </FormControl>
                                )}
                                onDayChange={(day) => {
                                    let df = moment(day)
                                        .startOf("week")
                                        .toDate();
                                    let dt = moment(day).endOf("week").toDate();
                                    setDateFrom(df);
                                    setDateTo(dt);
                                }}
                            />

                            <p style={{ marginLeft: 20 }}>-</p>
                            <DayPickerInput
                                value={dateTo === false ? "" : dateTo}
                                placeholder="End Date"
                                formatDate={formatDate}
                                parseDate={parseDate}
                                format="DD-MM-YYYY"
                                onDayChange={(day) => setDateTo(day)}
                                component={(props) => (
                                    <FormControl
                                        style={{
                                            marginLeft: 20,
                                            minWidth: 200,
                                        }}
                                    >
                                        <TextField {...props} />
                                    </FormControl>
                                )}
                            />

                            <IconButton
                                style={{
                                    marginLeft: "5px",
                                    marginTop: "-8px",
                                    color: "red",
                                    border: "red",
                                }}
                                color="primary"
                                variant="outlined"
                                onClick={() => {
                                    setDateFrom();
                                    setDateTo();
                                }}
                            >
                                <ClearIcon />
                            </IconButton>
                            <FormControl
                                style={{
                                    marginLeft: 20,
                                    minWidth: 200,
                                    display: "initial",
                                }}
                            >
                                <DayPickerInput
                                    value={day === false ? "" : day}
                                    placeholder="Filter By Day"
                                    formatDate={formatDate}
                                    parseDate={parseDate}
                                    format="DD-MM-YYYY"
                                    component={(props) => (
                                        <FormControl
                                            style={{
                                                marginLeft: 20,
                                                minWidth: 200,
                                            }}
                                        >
                                            <TextField {...props} />
                                        </FormControl>
                                    )}
                                    onDayChange={(dat) => setDayFrom(dat)}
                                />
                            </FormControl>
                            <IconButton
                                style={{
                                    marginLeft: "5px",
                                    marginTop: "-8px",
                                    color: "red",
                                    border: "red",
                                }}
                                color="primary"
                                variant="outlined"
                                onClick={() => {
                                    setDayFrom(false);
                                }}
                            >
                                <ClearIcon />
                            </IconButton>
                        </div>
                    </Grid>
                </Grid>
                {title === 'JCEnviro ' ? 
                <Grid container spacing={0}>
                <Grid item xs={12}>
                <FormControl
                style={{
                    minWidth: 200,
                    display: "initial",
                }}
                >
                        <TextField
                            label="Filter By Client Name"
                            value={clientName === false ? "" : clientName}
                            onChange={(event) => {
                                setClientName(event.target.value);
                            }}
                        />
                </FormControl>
                </Grid>
            </Grid>
            : ''}
                
            </StyledContent>
        );
    }
}
